import { bindActionCreators } from 'redux';
import {
  menuQuery,
  toggleMenuFilter,
  clearFilters,
  cartUpsert,
  goToCheckout,
  orderItemChangeCount,
  setManagerDiscount,
  changeDeliveryFee,
  changeOrderComment,
} from '../../stateManagement/engine/actions/OrderActions';
import { createNew, startEditing } from '../../stateManagement/engine/actions/EditDishActions';
import { connect } from 'react-redux';
import OrderManager from './OrderManager';
import {
  sideMenuDisplay,
  toggleCustomerDetailsSummary,
  displayModal,
  hideModal,
  goBack,
} from '../../stateManagement/engine/actions/SessionActions';
import { derivedOrderData } from '../../stateManagement/engine/selectors/derivedOrderData';
import {
  mergeExistingOrder,
  continueWithoutUnavailableDishes,
  cancelMergeOrder,
} from '../../stateManagement/engine/actions/OrderHistoryActions';
import { deliveryTypeSelector } from '../../stateManagement/engine/selectors/deliveryTypeSelector';
import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';

function mapStateToProps(state) {
  const { priceComponents, displayableDiscounts } = derivedOrderData(state);
  return {
    acceptsTip: state.session.acceptsTip,
    allowsManagerDiscount: state.session.allowsManagerDiscount,
    step: state.session.step,
    stepData: state.session.stepData,
    simplifiedMenu: state.session.simplifiedMenu,
    itemsHash: state.session.itemsHash,
    organization: state.session.organization,
    localeData: state.session.localeData,
    lowResMenuShown: state.session.lowResMenuShown,
    deliveryType: deliveryTypeSelector(state),
    query: state.order.query,
    filters: state.order.filters,
    orderItems: state.order.orderItems,
    customer: state.order.customer,
    address: state.order.address,
    unavailableOrderItems: state.order.unavailableOrderItems,
    displayCustomerDetailsSummary:
      state.session.displayCustomerDetailsSummary || state.session.step === FLOW_STEP.CHECKOUT,
    orderHistoryDisplayable: state.order.orderHistoryDisplayable,
    orderHistoryRaw: state.order.orderHistory,
    managerDiscount: state.order.managerDiscount,
    priceComponents,
    displayableDiscounts,
    manualDeliveryFee: state.order.manualDeliveryFee,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      menuQuery,
      toggleMenuFilter,
      clearFilters,
      cartUpsert,
      goToCheckout,
      orderItemChangeCount,
      editDishNew: createNew,
      editDishStartEditing: startEditing,
      sideMenuDisplay,
      toggleCustomerDetailsSummary,
      displayModal,
      hideModal,
      goBack,
      mergeExistingOrder,
      unavailableDishesOkClick: continueWithoutUnavailableDishes,
      unavailableDishesCancelClick: cancelMergeOrder,
      setManagerDiscount,
      onChangeDeliveryFee: changeDeliveryFee,
      changeOrderComment,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderManager);
